import { useState } from 'react';
// import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
// import okaidia from 'react-syntax-highlighter/dist/esm/styles/prism/okaidia';
// import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa';
import { docco, tomorrowNightBlue, github } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { Copy } from '../copy';

const inlineStyle = {
  display: 'inline',
  padding: '6px 8px',
  border: 0,
  borderRadius: 4,
};

// const syntaxStyle = tomorrowNightBlue;
// const syntaxStyle = tomorrowNightBlue;
const syntaxStyleInline = () => docco;

// const syntaxCustomStyle = { border: '1px solid #222', padding: 20, borderRadius: 8 };

const render = (str, secret) => (str && secret ? str.slice(0, 6) + '...' : str);

const syntaxStyle = (props) =>
  ({
    light: docco,
    default: tomorrowNightBlue,
  })[props.theme || (props.inline ? 'light' : 'default')];

const syntaxCustomStyle = (props) =>
  ({
    light: { padding: 20, borderRadius: 8 },
    default: { border: '1px solid #ccc', padding: 20, borderRadius: 8 },
  })[props.theme || (props.inline ? 'light' : 'default')];

const color = (props) =>
  ({
    light: 'black',
    default: props.inline ? 'black' : 'white',
  })[props.theme || 'default'];

export const CodeBlock = (props) => {
  const [show, setShow] = useState();

  const eyeNode = show ? <FaRegEyeSlash /> : <FaRegEye />;

  return (
    <div
      style={{
        position: 'relative',
        alignItems: props.inline ? 'center' : null,
        display: props.inline ? 'inline-flex' : null,
        ...(props.style || {}),
      }}
    >
      {true && (
        <div style={{ position: 'absolute', right: 10, zIndex: 10, ...(props.inline ? {} : { top: 10, right: 10 }) }}>
          <Copy value={props.code} onlyCheck style={{ color: color(props) }} />
        </div>
      )}
      {props.hideCode && eyeNode && (
        <div
          style={{
            position: 'absolute',
            cursor: 'pointer',
            right: 35,
            zIndex: 10,
            display: 'flex',
            alignItems: 'center',
          }}
          onClick={() => setShow(!show)}
        >
          {eyeNode}
        </div>
      )}

      <SyntaxHighlighter
        language={props.language}
        style={props.inline ? syntaxStyleInline(props) : syntaxStyle(props)}
        customStyle={{
          ...syntaxCustomStyle(props),
          ...(props.inline ? inlineStyle : {}),
          ...(props.copy ? { paddingRight: 40 } : {}),
          ...(eyeNode ? { paddingRight: 60 } : {}),
        }}
      >
        {props.children ? props.children : render(props.code, props.hideCode && !show)}
      </SyntaxHighlighter>
    </div>
  );
};
